function isMobileDevice() {
  return window.innerWidth <= 992;
}

function resetAllExcept(currentItem) {
  const allSubmenus = document.querySelectorAll(".footer .sub-menu");

  allSubmenus.forEach((submenu) => {
    if (submenu !== currentItem && !submenu.contains(currentItem)) {
      submenu.classList.remove("active");
      submenu.parentElement.querySelector("a").classList.remove("open");
    }
  });
}

function resetAll() {
  const submenus = document.querySelectorAll(".footer .sub-menu");
  const dropdownLinks = document.querySelectorAll(
    ".footer .menu-item-has-children > a"
  );

  submenus.forEach((item) => {
    item.classList.remove("active");
  });

  dropdownLinks.forEach((item) => {
    item.classList.remove("open");
  });
}

function setupPointerEvents() {
  const dropdownLinks = document.querySelectorAll(
    ".footer .menu-item-has-children > a"
  );

  if (!dropdownLinks) return;

  dropdownLinks.forEach((link) => {
    if (isMobileDevice()) {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        const dropdownItem = link.parentElement;
        const submenu = dropdownItem.querySelector(".sub-menu");

        if (!submenu) return;

        const isActive = submenu.classList.contains("active");

        if (isActive) {
          submenu.classList.remove("active");
          link.classList.remove("open");
          return;
        }

        resetAllExcept(submenu);

        link.classList.add("open");
        submenu.classList.add("active");
      });
    } else {
      resetAll();
    }
  });
}

function changePointerEventsFooterMobile() {
  setupPointerEvents();
  window.addEventListener("resize", setupPointerEvents);
}

export { changePointerEventsFooterMobile };
